
import AdminService from '@/services/admin-service';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import DefaultLayout from '@/components/DefaultLayout.vue';
@Component({
  components: { DefaultLayout }
})
export default class extends Vue {
  /* Properties */
  /* Store Actions */
  /* Watchers */
  /* Data */
  isAdminFiltered: boolean = true;
  logs: any[] = [];
  adminFilteredLogs: any[] = [];
  header: any[] = [
    {
      text: 'User',
      align: 'start',
      sortable: true,
      value: 'UserName'
    },
    {
      text: 'Activity Type',
      align: 'start',
      sortable: true,
      value: 'ActivityType'
    },
    {
      text: 'Description',
      align: 'start',
      sortable: true,
      value: 'Description'
    },
    {
      text: 'Customer',
      align: 'start',
      sortable: true,
      value: 'CustomerName'
    },
    {
      text: 'AccessTime',
      align: 'start',
      sortable: true,
      value: 'ActivityDateTime'
    }
  ];
  /* Utility Functions */
  /* Loaders */
  async loadLogEntries() {
    const response = await AdminService.getActivitiesByDate('');
    if (response) {
      this.adminFilteredLogs = response.data.filter((log: any) => log.IsAdmin === false);
      this.logs = response.data;
    }
  }
  /* Mounted */
  mounted() {
    this.loadLogEntries();
  }
  /* Created */
}
